// extracted by mini-css-extract-plugin
export default {"customCell":"ProjectTable_customCell__eNtu4","deleteButton":"ProjectTable_deleteButton__AoCx2"};